import axios from "axios";
import { BRANDS_URL, DEVICES_URL, DEVICE_MODELS_URL, DEVICE_OVERALL_URL, FORCE_REGISTER_URL, UPLOADED_FILES_URL, UPLOAD_EXCEL_URL } from "../config/urls";
import queryString from 'query-string';

export const useGetAllUploadedFiles = () => {

    return async () => {
        try {
            const res = await axios.get(UPLOADED_FILES_URL, {
                headers: { Authorization: 'bearer ' + localStorage.getItem('token') }
            });

            return res.data
        } catch (e) {
            return {}
        }
    }
};
